export default __webpack_public_path__ + "static/media/hand-pouring.b6a27e56.png";